import { ReactNode } from "react";
import CloseIcon from "../../assets/icons/x-close.svg";
import NoFiles from "../../assets/icons/no-files.svg";
import { format, parseISO } from "date-fns";

type boxProps = {
  addons?: string;
  children: ReactNode;
};
export const Boxrow = ({ addons, children }: boxProps) => {
  return (
    <span
      className={`tw-w-full tw-flex tw-flex-col lg:tw-flex-row tw-items-end tw-gap-[20px] lg:tw-gap-[10px] ${addons}`}
    >
      {children}
    </span>
  );
};

export const Boxcol = ({ addons, children }: boxProps) => {
  return (
    <span
      className={`tw-w-full tw-flex tw-flex-col tw-items-starttw- gap-[20px] lg:tw-gap-[10px] ${addons} `}
    >
      {children}
    </span>
  );
};

type TSubProps = {
  addOns?: string;
  title: string;
  subtitle?: string;
  highlight?: string;
  tclass?: string;
  sclass?: string;
};
export const Titlesubtitle = ({
  title,
  subtitle,
  highlight,
  tclass,
  sclass,
  addOns,
}: TSubProps) => {
  return (
    <div
      className={`tw-flextw- flex-col tw-items-start tw-gap-[4px] tw-mx-w-[90%] tw-text-neutral-700 ${addOns}`}
    >
      <h2
        className={`tw-my-0 tw-font-[700] tw-text-[1.3em] md:tw-text-[1.75em] tw-leading-[1.2em] ${tclass} `}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`tw-my-0 tw-mt-[5px] tw-font-[400] tw-text-[.9em] tw-leading-[1.4em] tw-text-neutral-700 ${sclass}`}
        >
          {" "}
          {subtitle} <strong className="tw-font-[400] tw-text-act-blue-300 ">{highlight}</strong>
        </p>
      )}
    </div>
  );
};

// modal header
type modalProps = {
  title: string;
  closeFn: () => void;
};
export const ModalHeader = ({ title, closeFn }: modalProps) => {
  return (
    <div className="tw-w-full  tw-flex tw-items-center tw-justify-between tw-gap-[20px] tw-px-[12px] tw-py-[12px]">
      <p className="tw-w-full tw-text-[1em] tw-text-center tw-font-[600] tw-text-neural-900">
        {title}
      </p>
      <img src={CloseIcon} alt="close" onClick={closeFn} />
    </div>
  );
};

// multi colored header
type multiHProps = {
  textOne: string;
  textTwo?: string;
  textThree?: string;
};
export const MultiHeaderText = (props: multiHProps) => {
  const { textOne, textTwo, textThree } = props;
  return (
    <p className="tw-text-[1em] tw-font-[600] tw-text-neutral-800 ">
      {" "}
      {textOne}{" "}
      <strong className="tw-text-[.75em] tw-font-[400] tw-text-act-blue-300 "> {textTwo} </strong>{" "}
      <strong className="tw-text-[.75em] tw-font-[400] tw-text-neutral-600 "> {textThree}</strong>{" "}
    </p>
  );
};

export function EmptyStateNoFiles({ text = "No transactions to show yet" }: { text?: string }) {
  return (
    <div className="empty-no-files">
      <img src={NoFiles} alt="No Files" />
      <p className="text-header-7 text-neutral-900">{text}</p>
    </div>
  );
}

export const DateCell = ({ value }: { value: string }) => {
  if (!value) return <p>N/A</p>;

  try {
    const date = parseISO(value);
    return <p>{format(date, "dd/MM/yyyy")}</p>;
  } catch (error) {
    return <p>Invalid Date</p>;
  }
};